export default __webpack_public_path__ + "static/media/radar.e2b3aa60.svg";